import RouterSection from '@/components/layout/RouterSection'

export default {
  path: '/public',
  name: 'public-index',
  component: RouterSection,
  redirect: '',
  children: [
    {
      path: 'certifiedcopyservice',
      name: 'certifiedcopyservice-step1',
      component: () => import('@/views/publicservice/CertifiedCopyServiceStep1.vue'),
      props : true
    },
    {
      path: 'certifiedcopyservice/step2/:receipt_no',
      name: 'certifiedcopyservice-step2',
      component: () => import('@/views/publicservice/CertifiedCopyServiceStep2.vue'),
      props : true
    },
    {
      path: 'certifiedcopyservice/step3/:receipt_no',
      name: 'certifiedcopyservice-step3',
      component: () => import('@/views/publicservice/CertifiedCopyServiceStep3.vue'),
      props : true
    },
    {
      path: 'certifiedcopyservice/step4/:receipt_no',
      name: 'certifiedcopyservice-step4',
      component: () => import('@/views/publicservice/CertifiedCopyServiceStep4.vue'),
      props : true
    },
    {
      path: 'certifiedcopyservice/step4/:receipt_no/:payment_history_seq',
      name: 'certifiedcopyservice-step4-payment',
      component: () => import('@/views/publicservice/CertifiedCopyServiceStep4.vue'),
      props : true
    },
    {
      path: 'translationandaudit',
      name: 'translationandaudit-step1',
      component: () => import('@/views/publicservice/TranslationStep1.vue'),
      props : true
    },
    {
      path: 'translationandaudit/step2/:receipt_no',
      name: 'translationandaudit-step2',
      component: () => import('@/views/publicservice/TranslationStep2.vue'),
      props : true
    },
    {
      path: 'translationandaudit/step3/:receipt_no',
      name: 'translationandaudit-step3',
      component: () => import('@/views/publicservice/TranslationStep3.vue'),
      props : true
    },
    {
      path: 'translationandaudit/step4/:receipt_no',
      name: 'translationandaudit-step4',
      component: () => import('@/views/publicservice/TranslationStep4.vue'),
      props : true
    },
    {
      path: 'translationandaudit/step4/:receipt_no/:payment_history_seq',
      name: 'translationandaudit-step4-payment',
      component: () => import('@/views/publicservice/TranslationStep4.vue'),
      props : true
    },
    {
      path: 'inpersonmeeting',
      name: 'inpersonmeeting-step1',
      component: () => import('@/views/publicservice/InPersonMeetingStep1.vue'),
      props : true
    },
    {
      path: 'inpersonmeeting/step2/:receipt_no',
      name: 'inpersonmeeting-step2',
      component: () => import('@/views/publicservice/InPersonMeetingStep2.vue'),
      props : true
    },
    {
      path: 'inpersonmeeting/step3/:receipt_no',
      name: 'inpersonmeeting-step3',
      component: () => import('@/views/publicservice/InPersonMeetingStep3.vue'),
      props : true
    },
    {
      path: 'writingandprinting',
      name: 'writingandprinting-step1',
      component: () => import('@/views/publicservice/WritingAndPrintingStep1.vue'),
      props : true
    },
    {
      path: 'writingandprinting/step2/:receipt_no',
      name: 'writingandprinting-step2',
      component: () => import('@/views/publicservice/WritingAndPrintingStep2.vue'),
      props : true
    },
    {
      path: 'writingandprinting/step3/:receipt_no',
      name: 'writingandprinting-step3',
      component: () => import('@/views/publicservice/WritingAndPrintingStep3.vue'),
      props : true
    },
    {
      path: 'research/step1/:receipt_no',
      name: 'research-step1',
      component: () => import('@/views/publicservice/ResearchServiceStep1.vue'),
      props : true
    },
    {
      path: 'research/step2/:receipt_no',
      name: 'research-step2',
      component: () => import('@/views/publicservice/ResearchServiceStep2.vue'),
      props : true
    },
    {
      path: 'research/step3/:receipt_no',
      name: 'research-step3',
      component: () => import('@/views/publicservice/ResearchServiceStep3.vue'),
      props : true
    },
    {
      path: 'research/step3/:receipt_no/:payment_history_seq',
      name: 'research-step3-payment',
      component: () => import('@/views/publicservice/ResearchServiceStep3.vue'),
      props : true
    }
  ]
}
